import React from 'react';
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, message } from 'antd';
import { CloudSyncOutlined, FileAddOutlined, ArrowLeftOutlined, ImportOutlined,
  FileZipOutlined } from '@ant-design/icons'
import SchemeRepository from '../../components/skos/SchemeRepository'
import NewElement from '../../components/editor/NewElement';
import Search from '../../components/search/Search';
import { RdfTriplet, SkosRepository, SkosScheme} from '../../redux';
import { getCountValue } from '../../virtuoso/helper';
import { makeURI } from '../../utils/uriUtil';
import { makePrefixIRIByType } from '../../utils/uriUtil';
import ImportConceptScheme from '../../components/import/ImportConceptScheme';
import ExportConceptScheme from '../../components/export/ExportConceptScheme';

const prefixURI = "http://www.w3.org/2004/02/skos/core#";
const predicatSkosDefinition = "http://www.w3.org/2004/02/skos/core#definition";

/**
 *  Отображение формы добавление нового элемента в каталоге
 * 
 *  Модальная форма на основе примера см. https://stackblitz.com/edit/ant-modal-form?file=index.js
 */
const showAdd = (formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, sksaNamespace) => {
    const extra =[
    //см. 
    { "uri": predicatSkosDefinition, 
      rules:[{ required: true, message: i18n.t('views.skos.schemeList.descriptionRequired') }]
    },
  ];

  return <Modal 
          style={{minWidth: 700}} 
          open={true} 
          title={i18n.t('views.admin.add_concept_scheme')} 
          cancelText={i18n.t('views.skos.common.cancel')}
          okText={i18n.t('views.skos.common.add')}
		      onCancel={onCancelOperation} 
          onOk={onFinishOperation}>	
        <NewElement 
          formRef={formRef}
          factory={factory}
          prefixURI={makePrefixIRIByType(sksaNamespace, "http://www.w3.org/2004/02/skos/core#ConceptScheme")}
          rdfType={"http://www.w3.org/2004/02/skos/core#ConceptScheme"}
          extra={extra}
          />          
	  </Modal>
}


/** Компонента для получения и отображения списка схем skos:ConceptScheme. 
 *  Доступные схемы фиксируются в skos.
 *  Линковка props и skos происходит в containers.js
 */
class ConceptSchemeList extends React.Component {

    state = {
      modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог добавление нового элемениа
    };

    formRef = React.createRef();
  
    onSearchByName (pattern) {
      const {onNameSearch, conditions} = this.props;
      if (onNameSearch) 
        onNameSearch(SkosRepository, pattern, conditions);
    }

    onRefresh (e) {
      e.preventDefault();
      const {conditions, lang} = this.props;
      this.props.onRefreshList(SkosRepository, conditions, lang);
    }
    onNewScheme(e){
      e.preventDefault();
      this.setState({modal:"add"});
    }

    onShowCatalogInformation(e){
      e.preventDefault();
      this.setState({modal:"info"});
    }

  onImportDialog(e){
    e.preventDefault();
    this.setState({modal:"import"});
  }

  onExportDialog(e){
    e.preventDefault();
    this.setState({modal:"export"});
  }

  cancelOperation(){
    this.setState({modal:"none"});
  };

  /** Вызывается при добавлении нового классификатора. Данные см. NewElement.js */
  submitOperation() {
    const { sksaNamespace, router, onSelected } = this.props;
    const form  = this.formRef.current;
    form.validateFields()
      .then(values => {
        //console.log("ConceptSchemeList.js submitOperation() Received values of form: ", values);
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))
            ? values.IRI : makeURI(sksaNamespace, values.IRI);
        //Проверим, что IRI отсутствует
        RdfTriplet.countSubject(IRI)
          .then ( response =>{
            const count = getCountValue(response.bindings);
            if (count>0){
              message.error(i18n.t('views.skos.schemeList.uriExists', { iri: IRI }));
              return;
            }
            //Добавление всегда идёт в каталог, который доступен для зарегистрированных пользователей
            const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
            const rdfType = values["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];
            //console.log("ConceptSchemeList.js submitOperation() ", IRI, rdfType, label.text, label.lang);
            const requests = [
              this.props.onAddElement(SkosRepository, IRI, rdfType, label.text, label.lang),
              this.props.onInsertProperty(SkosScheme, IRI, predicatSkosDefinition, values[predicatSkosDefinition], label.lang)
            ];            
            Promise.all(requests)
              .then (response =>{ 
                //const time = showMessageSuccess(store, "Добавление записи завершено успешно.");
                message.success(i18n.t('views.skos.schemeList.addSuccess'));
                this.setState({modal:"none"}); 
                if (router && onSelected)
                  onSelected(IRI, SkosScheme, router.navigate)                    
              })
              .catch(e => {  message.error(i18n.t('views.skos.schemeList.addError', { error: e })); });
          })
          .catch(e => {  
            message.error(i18n.t('views.skos.schemeList.iriUniquenessError', { error: e }));
          });
      })
      .catch(info => {
        message.error(i18n.t('skos.scheme.message.e_new', {detail: info}));
      });

    };
    
    render() {
        //console.log(this);
        const { modal } = this.state;
        const {taxonomy, isSignedIn, inGroup, factory, lang, conditions, sksaNamespace} = this.props;
        return (
            <div>
              <Row><h1>{i18n.t('views.admin.landing.schemes')}</h1></Row>
                <Row>
                    <Col className="csi_search_form_div" span={24} style={{}}><Search onSearch={(value) => this.onSearchByName(value)} /></Col>
                </Row>
                <Row>
                    <Col className="csi_asset_list" span={24} style={{}}>
                        <Row>
                          <Col span={22}>                          
                              <Tooltip placement="top" title={i18n.t('views.admin.return_admin_panel')}>
                                <Button icon={<ArrowLeftOutlined />} onClick={(e)=> this.props.router.navigate("/")}></Button>
                              </Tooltip>
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.adms.list_reload_title')}>
                                  <Button icon={<CloudSyncOutlined />} onClick={(e)=> this.onRefresh(e)}></Button>
                                </Tooltip>
                            </Col>
                            <Col span={2} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                              {isSignedIn && inGroup.PowerUser && (
                                <>
                                  <Tooltip placement="top" title={i18n.t('views.admin.add_concept_scheme')}>
                                    <Button icon={<FileAddOutlined />} onClick={(e)=> this.onNewScheme(e)}></Button>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.admin.import_conceptscheme')}>
                                    <Button icon={<ImportOutlined />} onClick={(e)=> {(this.onImportDialog(e))}} ></Button> 
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.skos.export.model')}>
                                    <Button icon={<FileZipOutlined />} onClick={(e)=> this.onExportDialog(e)}/>
                                  </Tooltip>                              
                                </>
                              )}
                            </Col>
                        </Row>
                        <Row id="SchemeRepository" ><Col span={24}><SchemeRepository {...this.props} /></Col></Row>
                    </Col>
                </Row>
                { modal=="add" && showAdd( this.formRef, factory, ()=>this.submitOperation(), ()=>this.cancelOperation(), sksaNamespace)}
                { modal=="import" && <ImportConceptScheme open={true} onClose={()=> this.cancelOperation()} />}
                { modal=="export" && <ExportConceptScheme open={true} onClose={()=> this.cancelOperation()} conditions={conditions}/>}
            </div>            
        )
    }
}

export default ConceptSchemeList;
